class LoginController{
    /*@ngInject*/
    constructor(SocketService,$state,SessionService,UserService, EventService){
        this.socket = SocketService;
        this.$state = $state;
        this.session = SessionService;
        this.userService = UserService;
        this.event = EventService;
    }
    $onInit(){
        let start = this.session.get('_ct',false);
        if(start!==false && (new Date()).getTime() - start <= 86400000){
            this.$state.go('cheat');
            return;
        }
        this.connecting = true;
        this.onOpen = this.event.subscribe('websocket:open',()=>{
            this.connecting = false;
            this.userService.loadUserFromSession();
            if(!this.userService.isValid()){
                return;
            }
            this.socket.authenticate();
            this.user = this.userService.getUser();
            console.log(this.user);
            this.socket.send('associateAs',{name:this.user.name});
            if(this.user.compete===1) {
                this.socket.send('room', {id: null});
            }else if(this.user.compete===2){
                this.socket.send('room', {id:this.user.classId});
            }else if(this.user.compete===3){
                this.socket.send('room', {id:this.user.schoolId});
            }
            this.session.set('levels',this.user.levels);
            return this.$state.go("dashboard");
        });
    }
    $onDestroy(){
        this.onOpen();
    }
    login(isValid){
        if(!isValid){
            return false;
        }
        this.session.set('lastUsed',this.user.name,true);
        this.session.set('user',this.user);
        this.socket.send('associateAs',{name:this.user.name});
        return this.$state.go("dashboard");
    }
}

export default LoginController;


// WEBPACK FOOTER //
// ./public/app/login/login.controller.js